const state = {
  // 页面宽度
  pageWidth: 1200,
  mainPageRoute: "",
  mainTitle: "",
  logo: "",
  id: null
};

const mutations = {
  updatePageWidth(state, width) {
    state.pageWidth = width;
  },
  updateMainPageRoute(state, routeName) {
    state.mainPageRoute = routeName;
  },
  updateMainTitle(state, mainTitle) {
    state.mainTitle = mainTitle;
  },
  updateLogo(state, logo) {
    state.logo = logo;
  },
  updateId(state, id) {
    state.id = id;
  }
};
const actions = {
  updateServerConfig({ commit }, config) {
    if (config.width) {
      commit("updatePageWidth", config.width);
    }
    if (config.homeRoute) {
      commit("updateMainPageRoute", config.homeRoute);
    }
    if (config.title) {
      commit("updateMainTitle", config.title);
    }
    if (config.logo) {
      commit("updateLogo", config.logo);
    }
    if (config.id) {
      commit("updateId", config.id);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/privateConfig.js